import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

/** Notes attached to meetings. The student reads them too, unlike the coach's private notes. */
@Injectable({providedIn: 'root'})
export class CoachAppointmentNoteService {

  private apiPrefix = '/coach';

  constructor(
    private api: ApiService,
  ) {
  }

  /** One student's notes across all their meetings, newest first. */
  getStudentNotes(studentId: number, queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/students/${studentId}/appointment-notes`, queryString);
  }

  createNote(appointmentId: number, content: string): Observable<any> {
    return this.api.post(`${this.apiPrefix}/appointments/${appointmentId}/notes`, {content});
  }

  updateNote(noteId: number, content: string): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/appointment-notes/${noteId}`, {content});
  }

  deleteNote(noteId: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/appointment-notes/${noteId}`);
  }
}
